// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from '../actions';

const splitTreatments = (state = {}, action) => {
  switch (action.type) {
    case actions.SPLIT_TREATMENTS_FETCH_SUCCESS:
      return {
        ...state,
        ...action.splitTreatments,
      };

    default:
      return state;
  }
};

export default splitTreatments;
